
import React from "react";
import { useTranslation } from "react-i18next";

interface PointDisplayProps {
  currentPoint: string;
  currentAttempt: number;
  maxAttempts: number;
  distance: string;
  isChippingTest: boolean;
  getFormattedPoint: (point: string) => string;
  currentLevel?: 1 | 2 | 3;
}

const PointDisplay: React.FC<PointDisplayProps> = ({
  currentPoint,
  currentAttempt,
  maxAttempts,
  distance,
  isChippingTest,
  getFormattedPoint,
  currentLevel = 1, // Niveau 1 par défaut
}) => {
  const { t } = useTranslation('training');
  
  console.log("PointDisplay Level1 - currentPoint:", currentPoint);
  console.log("PointDisplay Level1 - distance:", distance);
  
  // Déterminer la distance affichée spécifiquement pour le niveau 1
  const getDistanceByLevel = () => {
    // Si une distance est explicitement fournie, l'utiliser
    if (distance) {
      // Ajouter l'unité "m" si c'est un nombre sans unité
      if (!isNaN(Number(distance.replace('m', ''))) && !distance.includes('m')) {
        return `${distance}m`;
      }
      return distance;
    }
    
    // Distances du niveau 1
    if (currentPoint === 'G') return '6m';
    if (currentPoint === 'H') return '10m';
    if (currentPoint === 'I') return '12m';
    if (currentPoint.startsWith('G')) return '6m';
    if (currentPoint.startsWith('H')) return '10m';
    if (currentPoint.startsWith('I')) return '12m';
    
    // Par défaut: utiliser le point formaté
    return getFormattedPoint(currentPoint);
  };
  
  const displayDistance = getDistanceByLevel();

  return (
    <div className="text-center mb-4">
      <h3 className="text-xl font-semibold mb-1">
        {t('interface.currentPoint')}: {currentPoint} - {t('interface.attempt')} {currentAttempt + 1}/{maxAttempts}
      </h3>
      <p className="text-green-600 font-medium">
        {t('interface.distance')}: {displayDistance}
      </p>
    </div>
  );
};

export default PointDisplay;
